export default __webpack_public_path__ + "static/media/logo.5f1a0a04.jpeg";